<template>
  <div>
    <header-portrate />
    <exports-print ref="exportbar" />
    <div style="margin-bottom:70px;" :style="`direction:${lang.dir}`">
      <tabs-comp :tabs="tabs" />
      <v-row class="m-2">
        <v-col cols="12" md="5"><label>{{lang.status_category}}</label><b-form-select :options="StatusLists" v-model="currentStatus" @change="getExpensesTypes()" /></v-col>
        <v-col cols="12" md="3"><b-form-checkbox v-model="showArchived" @change="getExpensesTypes()">{{lang.status_include_archived}}</b-form-checkbox></v-col>
        <v-col cols="12" md="4"><b-button :disabled="loading || actionBusy" variant="success" v-b-toggle.expense_type @click="resetMe({id:0,name_ar:'',name_en:'',bgColor:'#ffffff',color:'#000000'})">{{lang.add_new_status}}</b-button></v-col>
        <v-col cols="12">
          <p v-if="loading">{{lang.status_loading}}</p>
          <v-simple-table>
            <thead><tr><th>{{lang.status_code}}</th><th>{{lang.status_name_ar}}</th><th>{{lang.status_name_en}}</th><th>{{lang.status}}</th><th>{{lang.action}}</th></tr></thead>
            <tbody>
              <tr v-for="item in expenses" :key="item.id">
                <td :style="{backgroundColor:item.bgColor,color:item.color}">{{item.value}}</td><td>{{item.name_ar}}</td><td>{{item.name_en}}</td>
                <td>{{item.archived?lang.status_archived:lang.status_active}}</td>
                <td><b-button size="sm" :disabled="loading || actionBusy" @click="resetMe(item)" v-b-toggle.expense_type>{{lang.update}}</b-button>
                  <b-button v-if="item.archived" size="sm" :disabled="loading || actionBusy" @click="changeArchive(item,true)">{{lang.status_restore}}</b-button>
                  <b-button v-else-if="item.can_archive" size="sm" variant="outline-danger" :disabled="loading || actionBusy" @click="changeArchive(item,false)">{{lang.status_archive}}</b-button>
                  <span v-else>{{lang.status_workflow_protected}}</span>
                </td>
              </tr>
              <tr v-if="!loading && !expenses.length"><td colspan="5">{{lang.status_no_results}}</td></tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>
    </div>
    <Footer />
    <addStatusType ref="expensType" />
  </div>
</template>
<script>
import TabsComp from '@/components/tabsComp.vue';
import HeaderPortrate from '@/components/Header-Portrate.vue';
import Footer from '@/components/Footer.vue';
import addStatusType from '@/components/addStatusType.vue';
import ExportsPrint from '@/components/exports-print.vue';
import categories from '../../../php/includes/classes/status-categories.json';
import {contextualTabs} from '@/navigation-context';
import axios from 'axios';
export default {
  components:{TabsComp,HeaderPortrate,Footer,addStatusType,ExportsPrint},
  data(){return {currentStatus:'Calendar',showArchived:false,expenses:[],loading:false,actionBusy:false,requestSerial:0};},
  computed:{
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
    StatusLists(){return categories.map(row=>({value:row.value,text:this.lang.langname==='ar'?row.ar:row.en}));},
    tabs(){const state=this.$store.getters['state'];return contextualTabs([],state.menu,state.licenseType,state.group_id,this.$route.path,this.lang.langname,localStorage.getItem('currentMenu'));},
  },
  methods:{
    collectSearch(){return {module:'statusOptions',elements:{phrase:this.currentStatus,include_archived:this.showArchived?1:0,language:this.lang.langname==='en'?'en':'ar'}};},
    resetMe(item){this.$refs.expensType.resetValues(item,this.currentStatus);},
    async getExpensesTypes(){
      const serial=++this.requestSerial;this.loading=true;
      const post=new FormData();post.append('type','getStatusOptions');post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));post.append('defBranch',localStorage.getItem('defBranch'));
      post.append('data[phrase]',this.currentStatus);post.append('data[include_archived]',this.showArchived?1:0);
      try{const {data}=await axios.post(this.$store.state.SAMCOTEC.r_path,post);if(serial!==this.requestSerial)return false;
        if(Number(data?.error?.number)!==200||!Array.isArray(data.results?.data))throw new Error('invalid');this.expenses=data.results.data;return true;
      }catch(error){if(serial===this.requestSerial)this.$snotify.error(this.lang.status_load_failed,this.lang.alert);return false;}
      finally{if(serial===this.requestSerial)this.loading=false;}
    },
    async changeArchive(item,restore){
      if(this.actionBusy||this.loading||!item?.id||(!restore&&!item.can_archive))return false;
      if(!window.confirm(restore?this.lang.status_restore_confirm:this.lang.status_archive_confirm))return false;
      this.actionBusy=true;const phrase=this.currentStatus;
      const post=new FormData();post.append('type',restore?'restoreStatusOption':'archiveStatusOption');post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));post.append('defBranch',localStorage.getItem('defBranch'));post.append('data[id]',item.id);
      try{const {data}=await axios.post(this.$store.state.SAMCOTEC.r_path,post);const saved=data?.results?.data;
        if(Number(data?.error?.number)!==200||Number(saved?.id)!==Number(item.id)||saved.archived!==!restore||saved.option_phrase!==phrase)throw new Error('invalid');
        if(this.currentStatus===phrase)await this.getExpensesTypes();return true;
      }catch(error){this.$snotify.error(this.lang[error.response?.data?.error?.code]||this.lang.status_save_failed,this.lang.alert);return false;}
      finally{this.actionBusy=false;}
    },
    async statusSaved(row,phrase){if(phrase===this.currentStatus)await this.getExpensesTypes();},
  },
  created(){this.getExpensesTypes();},
  beforeDestroy(){this.requestSerial++;},
}
</script>
